import {
  validarData,
  getNumber,
  checkEmail,
  removeSymbols,
} from '@utils/Format'

export const required = (v) => !!v || 'Campo obrigatório'

export const notEmpty = (v) => !!v.trim() || 'O campo não pode estar vazio'

export const notOnlyWhitespace = (v) =>
  !v || !!String(v).trim() || 'O campo não pode conter apenas espaços'

export const data = (v) => !!validarData(v) || 'Formato inválido'

export const dateNotRequired = (v) => {
  const value = String(v || '')
  return value.length < 10 || !!validarData(value) || 'Formato inválido'
}

export const dataMes = (v) => !!validarData(v, 'MM/YYYY') || 'Formato inválido'

export const positive = (v) => getNumber(v) >= 1 || 'Deve ser maior que 0'

export const positiveOrUnfilled = (v) =>
  getNumber(v) >= 0 || !v || 'Deve ser maior ou igual a 0 ou estar vazio'

// Validates that a numeric field is not null/undefined/empty (0 is allowed).
export const requiredNumber = (v) =>
  (v !== null && v !== undefined && v !== '') || 'Campo obrigatório'

// Validates that a number is strictly greater than zero.
export const positiveNumber = (v) =>
  Number(v) > 0 || 'Valor deve ser maior que zero'

export const taxMinReal = (v) => getNumber(v) >= 2.99 || 'Valor mínimo: R$ 2,99'

export const taxMinPerc = (v) => getNumber(v) >= 0.01 || 'Valor mínimo: 0,01 %'

export const email = (v) => !v || checkEmail(v) || 'Formato inválido'

export const isGreaterThanOrEqual = (a, b) =>
  a <= b || 'O segundo valor deve ser maior ou igual ao primeiro'

export const emails = (v) =>
  v.split(';').every((a) => {
    return checkEmail(a) || !a
  }) || 'Formato inválido'

export const cep = (v) => !v || v.length === 9 || 'Formato inválido'

// cpf, cpnj, cpf_cnpj, telefone

export const cpf = (v) => {
  if (typeof v !== 'string') return 'CPF inválido'

  v = v.replace(/[\s.-]/g, '')

  if (v.length !== 11) return 'CPF inválido'

  if (/^(\d)\1+$/.test(v)) return 'CPF inválido'

  let sum = 0
  let rest

  for (let i = 0; i < 9; i++) {
    sum += parseInt(v.charAt(i)) * (10 - i)
  }

  rest = (sum * 10) % 11

  if (rest === 10 || rest === 11) rest = 0

  if (rest !== parseInt(v.charAt(9))) return 'CPF inválido'

  sum = 0

  for (let i = 0; i < 10; i++) {
    sum += parseInt(v.charAt(i)) * (11 - i)
  }

  rest = (sum * 10) % 11

  if (rest === 10 || rest === 11) rest = 0

  if (rest !== parseInt(v.charAt(10))) return 'CPF inválido'

  return true
}

export const cnpj = (v) => !v || v.length === 18 || 'Formato inválido'

export const cpf_cnpj = (v) =>
  (v && (v.length === 14 || v.length === 18)) || 'Formato inválido'

export const fullName = (v) =>
  v.split(' ').length > 1 || 'Insira seu nome completo'

export const phone = (v) => v.length >= 14 || 'Formato inválido'

export const phoneWithCountryCodeBrazil = (v) =>
  (v && v.length >= 18) || 'Formato inválido'

export const isBrazilCode = (v) => {
  const firstTwoDigits = removeSymbols(v).slice(0, 2)
  return firstTwoDigits === '55' || 'O código de país deve ser do Brasil (55)'
}

export const cardNumber = (v) => v.length === 19 || 'Formato inválido'

export const cardCVC = (v) => v.length === 3 || 'Formato inválido'

export const cardVenc = (v) => v.length === 5 || 'Formato inválido'

export const bankDetails = {
  bankCode: (v) => /^\d{3}$/.test(v) || 'Código do banco deve ter 3 dígitos',
  agencyCode: (v) =>
    !v ||
    /^\d{1,4}(-\d{1})?$/.test(v) ||
    'Agência deve ter 5 dígitos, incluindo o dígito verificador',

  accountNumber: (v) =>
    /^\d{1,12}(-\d{1,2})?$/.test(v) ||
    'Conta deve ter entre 6 e 12 dígitos, incluindo o dígito verificador',
}

export default {
  required,
  requiredNumber,
  positiveNumber,
  bankDetails,
  notEmpty,
  notOnlyWhitespace,
  data,
  dataMes,
  dateNotRequired,
  phone,
  phoneWithCountryCodeBrazil,
  isBrazilCode,
  positive,
  positiveOrUnfilled,
  taxMinReal,
  taxMinPerc,
  email,
  emails,
  cep,
  cardNumber,
  cardCVC,
  cardVenc,
  cpf,
  cnpj,
  cpf_cnpj,
  fullName,
  isGreaterThanOrEqual,
}
